import type {ResourceType, Status} from "../types";

export enum ModalType {
    generateChecklist = "generateChecklist",
    generateDocuments = "generateDocuments",
    generateDocument = "generateDocument",
    sendToDokumentflyt = "sendToDokumentflyt",
    sendToDokumentflytStandalone = "sendToDokumentflytStandalone",
}

export type TopicMeta = {
    topicId: string;
    resourceId: string;
    resourceTypeId?: ResourceType;
    name: string;
};

export type CollectionMeta = {
    id: string;
};

export type ExportDocument = {
    id: string;
    name: string;
    selected: boolean;
    resourceTypeId?: ResourceType;
};

export type DeliveryFormat = "doc" | "zip" | "email";

/** The generate modal's one in-flight flag. The shell owns it; each tab sets
 *  it around its own request and every tab reads it to lock its buttons. A
 *  successful export closes (unmounts) the modal, so it never clears it. */
export type ModalBusyProps = {
    busy: boolean;
    onBusyChange: (busy: boolean) => void;
};

export type GenerateButtonsInnerProps = {
    isChecklist?: boolean;
    isStandalone: boolean;
    isFetching: boolean;
    className?: string;
    topicMeta: TopicMeta;
    documents: ExportDocument[];
    collectionMeta?: CollectionMeta;
    labels?: string[];
    status?: (string | Status)[];
};
